import { FC, useState } from 'react';
import { RRule, Weekday } from 'rrule';
import { connect } from 'react-redux';

import InputLabelWrapper from '~src/shared/form/inputs/InputLabelWrapper';
import Dialog from '~src/shared/dialogs/dialog/Dialog';
import { getText, RRULE_GERMAN } from '~src/modules/okrs/constants/rruleTranslations';
import { StoreI } from '~src/rootReducer';
import { getSystemLocale } from '~src/services/session';

import { ValueContainer } from './repeatSelector.sc';
import RepeatFormModal from './RepeatFormModal';

interface StateProps {
  systemLocale: string;
}

interface OwnProps {
  error?: string;
  value?: string;
  onChange: (val: string) => void;
  label: string;
}

type Props = StateProps & OwnProps;

const RepeatSelector: FC<Props> = props => {
  const [modal, setModal] = useState(false);

  const showModal = () => setModal(true);

  const hideModal = () => setModal(false);

  const change = (value: string) => {
    props.onChange(value);
    hideModal();
  };

  const interval = props.value ? RRule.fromString(props.value).options.interval : 1;

  return (
    <InputLabelWrapper
      insideForm
      valid={!props.error}
      hasValue={!!props.value}
      error={props.error}
      label={props.label}
      labelKey={props.label}
    >
      <>
        <Dialog show={modal} onHide={hideModal}>
          <RepeatFormModal value={props.value} hide={hideModal} onSubmit={change} />
        </Dialog>
        <ValueContainer onClick={showModal} $valid={!props.error}>
          {props.value &&
            RRule.fromString(props.value).toText(
              (id: string | number | Weekday) => getText(id, interval, props.systemLocale),
              props.systemLocale === 'de_DE' ? RRULE_GERMAN : undefined,
            )}
        </ValueContainer>
      </>
    </InputLabelWrapper>
  );
};

const mapStateToProps = (state: StoreI): StateProps => ({
  systemLocale: getSystemLocale(state),
});

const RepeatSelectorConnected = connect(mapStateToProps)(RepeatSelector);
export default RepeatSelectorConnected;
